export default "__VITE_ASSET__eccf0a49__"